import { Box } from '@mui/material';
import { Title } from 'react-admin';

const GOOGLE_DOC_PREVIEW_URL =
	'https://docs.google.com/document/d/1NBGwtq4tAj8xjIPq0cii8wWavNbU_gxR/preview';

const SystemFunctions = () => {
	return (
		<Box sx={{ height: 'calc(100vh - 80px)', width: '100%', p: 1 }}>
			<Title title="פונקציות מערכת" />
			<iframe
				src={GOOGLE_DOC_PREVIEW_URL}
				title="פונקציות מערכת"
				style={{ width: '100%', height: '100%', border: 'none' }}
			/>
		</Box>
	);
};

export default SystemFunctions;
